module.exports = __webpack_public_path__ + "img/7.947e66ba.svg";